import { GTM_EVENT_PAGE_NAMES, URLS } from "@/constants/constants";
import HomeIcon from "@icons/home/home-white.svg";
import RefineIcon from "@icons/refine/refine-white.svg";
import TextIcon from "@icons/text/text_white.svg";
export const DOWNLOAD = "Download";
export const PDP_REPLACE_MODAL_TITLE = "Are you sure you want to replace the copy?";
export const PDP_REPLACE_MODAL_DESCRIPTION =
  "If you click “Yes, replace,” only the basic product description will remain and you won’t be able to return to any previous versions. Please be aware of the compute for generating new work and its impact on sustainability.";
export const PDP_COPY_HEADING = "Your copy is ready";
export const PDP_COPY_DESCRIPTION = `Your copy is now ready and accessible from your “Saved Work” area. This new copy will replace any previously generated versions related to this specific GTIN. Be advised that this is not campaign-ready copy and will still need to go through proper legal approval.`;
export const CREATE_MORE_COPY = "Create more text";
export const REPLACE_COPY = "Replace copy";
export const CREATE_MORE_TEXT = "Return to your Project copy list to";
export const GTIN = "GTIN";
export const REFINE_PDP_COPY_TITLE = "Refine copy inputs";
export const AI_GENERATED_LABEL = "AI Generated";
export const STANDARD_TITLE = "Standard title";
export const CUSTOMER_SPECIFIC_DESCRIPTION_WITH_BRAND = "Customer-Specific description with brand";
export const CUSTOMER_SPECIFIC_DESCRIPTION_WITHOUT_BRAND = "Customer-Specific description without brand";
export const LONG_CUSTOM_PRODUCT_DESCRIPTION = "Long Custom Product Description";
export const LONG_BULLETS = "long bullets";
export const CUSTOM_SHORT_DESCRIPTION = "custom short description";
export const SHORT_BULLETS = "short bullets";
export const DESCRIPTION_MINIMUN_CHARACTER_ERROR =
  "Content that meets the character minimum (50/250) is suggested for better engagement and SEO.";
export const CREATE_MORE = "Create more copy";
export const GO_TO_DASHBOARD = "Go to dashboard";
export const EMPTY_SYSTEM_ERROR = "The system can't retrieve this information, please enter the appropriate content to proceed.";

export const PDP_COPY_NEXT_ACTIVITY = {
  activities: [
    {
      href: URLS.HOME,
      title: GO_TO_DASHBOARD,
      description: "If you're satisfied with your text, you can access it from the Saved Work area and download it at a later time.",
      icon: HomeIcon,
      pageName: GTM_EVENT_PAGE_NAMES.GENERATED_COPY,
    },
    {
      href: "",
      title: REFINE_PDP_COPY_TITLE,
      description: "Make adjustments and tailor your results even further by editing the description or adding SEO keywords.",
      icon: RefineIcon,
      pageName: GTM_EVENT_PAGE_NAMES.GENERATED_COPY,
      className: "event_refine_copy_output_click",
    },
    {
      href: "",
      title: CREATE_MORE,
      description: `Continue on within your workflow and create copy for specific GTINs. `,
      icon: TextIcon,
      pageName: GTM_EVENT_PAGE_NAMES.GENERATED_COPY,
    },
  ],
};
export const seoKeywordsToggle = "Show SEO keywords";

export const TEXT_FORMAT_OPTIONS = [
  { id: "1", label: "TXT", format: "text" },
  { id: "2", label: "CSV", format: "csv" },
];

export const ariaLabelseoKeywordsToggle = "Show S.E.O keywords";
export const IMPROVE_TRANSLATION = "Improve Translation";
export const BACK_TO_ORIGINAL = "Back to Original";
export const TRANSLATION_PROVIDER = {
  API: "API",
  LLM: "LLM",
} as const;

export const FLOW_TYPE_PDP = "pdp";
